import throttle from 'lodash/throttle';

export default {

  init() {
    this.navToggle();
    this.subnavToggle();
    this.dropdownToggle();
    this.headerOffset();
    this.scrollbarWidth();
    this.eventListeners();

    $('html').removeClass('no-js').addClass('js');
  },

  // Mobile nav toggle
  navToggle() {
    $('.header__nav-toggle').on('click', function(e) {
      e.preventDefault();

      let $toggle = $(this);
      let $menu = $('.header__nav');

      $menu.toggleClass('is-nav-active');
      $('html').toggleClass('is-nav-open', $menu.hasClass('is-nav-active'));
      $('html').removeClass('is-dropdown-open');

      Common.navClickOutside();
    });

    $('.header__nav .close').on('click', function(e) {
      $('.header__nav-toggle').trigger('click');
    });

  },

  // Mobile subnav and Desktop mega-dropdowns
  subnavToggle() {
  	$('.nav-has-children > a, .nav-has-children > button').on('click', function(e) {
  		e.preventDefault();

  		let $toggle = $(this);
  		let $node = $(this).parent();

  		if(!Common.isMobile()) {
  			$('.nav-has-children.is-open').not($node).removeClass('is-open');
  		}

  		$node.toggleClass('is-open');
  		$('html').toggleClass('is-dropdown-open', $node.hasClass('is-open'));

  		if($node.hasClass('is-open')) {
  			$node.find('input[type=text]').first().focus();
  		} else {
  			$node.find('input[type=text]').first().blur();
  		}

  		Common.navClickOutside();
  		Common.navEscape();
  	});
  },

  // Mobile and Desktop secondary dropdowns
  dropdownToggle() {
  	$('.nav-has-dropdown > a, .nav-has-dropdown > button').on('click', function(e) {
  		e.preventDefault();

  		let $toggle = $(this);
  		let $node = $(this).parent();

  		if(!Common.isMobile()) {
  			$('.nav-has-dropdown.is-open').not($node).removeClass('is-open');
  		}

  		$node.toggleClass('is-open');

  		Common.navClickOutside();
  		Common.navEscape();
  	});
  },

  // Close nav and dropdowns on click outside
  navClickOutside() {
  	$('.site-header').on('click.nav', function(e) {
  		e.stopPropagation();
  	});

  	$(window).on('click.nav', function(e) {
  		// Mobile nav
  		if($('html').hasClass('is-nav-open')) {
  			Common.navState();
  		}
  		// Mega dropdowns
  		if($('html').hasClass('is-dropdown-open')) {
  			Common.navState();
  		}
  		// Secondary dropdowns
  		if($('.nav-has-dropdown.is-open').length) {
  			Common.navState();
  		}
  		// Remove listeners
  		$(window).off('click.nav')
  		$('.header__nav').off('click.nav');
  	});
  },

  navEscape() {
  	function escapeKey(e) {
      if (e.keyCode === 27) {
        Common.navState();
        $(document).off('keyup.nav');
      }
    }

    $(document).on('keyup.nav', escapeKey);
  },

  navState() {
  	// Mobile nav
    $('html').removeClass('is-nav-open');
    $('.header__nav').removeClass('is-nav-active');
    // Mega dropdowns
    $('html').removeClass('is-dropdown-open');
    $('.nav-has-children').removeClass('is-open');
    // Secondary dropdowns
    $('.nav-has-dropdown').removeClass('is-open');
  },

  headerOffset() {
  	let root = document.querySelector(':root');
  	let $header = $('.site-header');
  	let headerOffset = $header.outerHeight() - window.scrollY;
  	headerOffset =  (headerOffset > 0) ? headerOffset : 0;

  	root.style.setProperty('--header-offset', `${headerOffset}px`);
  },

  scrollbarWidth() {
    let scrollbarWidth = window.innerWidth - document.body.clientWidth;
    let root = document.querySelector(':root');

    root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  },

  eventListeners() {
    window.addEventListener('resize', throttle(function() {
      Common.navState();
      Common.scrollbarWidth();
    }), 200);

    window.addEventListener('scroll', throttle(function() {
      Common.headerOffset();
    }), 200);
  },

  isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

};
